import { forwardRef } from "react";
import ErrorMessage from "./ErrorMessage";

const HiddenField = forwardRef((props, ref) => {
  const { error, ..._props } = props;
  return (
    <>
      <input ref={ref} type="hidden" {..._props} />
      {error && <ErrorMessage msg={error} />}
    </>
  );
});
HiddenField.displayName = "HiddenField";
export default HiddenField;
